import Head from 'next/head';
import { useRouter } from 'next/router';

import { buildCanonicalUrl } from '../../utils/canonical-url';

export const SeoMetaTags = () => {
  const router = useRouter();
  const { route, query, asPath } = router;

  // Derived from the matched route, not asPath, so the /toode/ and /listing/ spellings of
  // a listing all point at the one official /product/ address instead of self-referencing.
  const canonicalUrl = buildCanonicalUrl(route, query, asPath);

  return (
    <Head>
      <link rel="canonical" href={canonicalUrl} />
    </Head>
  );
};
